var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1527 26.906C35.8323 20.2609 42.1396 16.3637 42.1396 16.3637C42.1396 16.3637 39.6822 12.8084 35.5522 11.8938C31.4243 10.9771 29.3583 12.1224 27.2963 12.9813C25.2324 13.8424 24.2025 13.8424 24.2025 13.8424C21.224 13.8424 19.0466 10.6887 13.3718 12.1245C9.46225 13.1111 5.34662 17.6243 4.60302 23.0108C3.85942 28.3994 5.46408 35.2751 8.55794 40.604C11.6518 45.937 14.8034 47.9412 17.0404 47.9988C19.2774 48.0544 21.5103 46.3963 24.2025 45.9925C26.8968 45.5929 28.5549 46.9689 31.1977 47.7125C33.8301 48.4541 34.753 47.7661 37.7851 45.1872C40.8253 42.6082 43.5773 35.2113 43.5773 35.2113C43.5773 35.2113 38.4731 33.5551 37.1527 26.906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3068 7.59462C34.2317 4.61411 33.241 0 33.241 0C33.241 0 29.1337 0.720969 26.3817 3.58412C23.6318 6.44938 24.087 10.9749 24.087 10.9749C24.087 10.9749 28.3818 10.5732 31.3068 7.59462Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.4de59cd762234ed2c0afb5f49769fa54.svg";
export { ForwardRef as ReactComponent };